<sw-page-head [subtitle]="'HOME.SUBTITLE' | translate" [title]="'HOME.TITLE' | translate"></sw-page-head>

<div class="container">
</div>
